import { render, staticRenderFns } from "./Registrar.vue?vue&type=template&id=3adac31a"
import script from "./Registrar.vue?vue&type=script&lang=js"
export * from "./Registrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports